<template>
  <div class="message-list-wrapper">
    <div class="message-list-item-wrap" v-for="item in items" :key="item.id">
      <div class="message-list-item">
        <div class="message-list-item-title">
          <span :style="getTypeStyleByItem(item)">{{
            MESSAGE_TYPE_TEXT[item.type]
          }}</span>
          <span class="interline">|</span>
          <span>{{ item.title }}</span>
        </div>
        <div class="message-list-item-status">
          <span :class="{ 'status-unread': item.status === '未读' }">{{
            item.status
          }}</span>
          <span class="interline">|</span>
          <el-button type="text" size="small" @click="showDetailDialog(item)">
            查看
          </el-button>
        </div>
      </div>
      <div class="message-list-item-time">时间：{{ item.time }}</div>
    </div>
    <MessageDetailDialog ref="messageDetailDialog" @onPageJump="onPageJump" />
  </div>
</template>

<script>
import MessageDetailDialog from "./messageDetailDialog.vue";
import { MESSAGE_TYPE, MESSAGE_TYPE_TEXT } from "./config";
export default {
  name: "messageList",
  components: { MessageDetailDialog },
  props: {
    items: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      MESSAGE_TYPE: Object.freeze(MESSAGE_TYPE),
      MESSAGE_TYPE_TEXT: Object.freeze(MESSAGE_TYPE_TEXT),
    };
  },
  methods: {
    // 处理消息类型样式
    getTypeStyleByItem(item) {
      const type = Number(item.type);
      if (type === MESSAGE_TYPE.TASK) {
        return "color: #F66717;";
      } else if (type === MESSAGE_TYPE.ACCEPT) {
        return "color: #0052FF;";
      } else if (type === MESSAGE_TYPE.SETTLE) {
        return "color: #F5AD42;";
      } else {
        return "color: #333333;";
      }
    },
    showDetailDialog(item) {
      const tempData = {
        ...item,
        typeName: MESSAGE_TYPE_TEXT[item.type],
      };
      this.$refs.messageDetailDialog.show(tempData);
      this.$emit("onMsgItemClick", tempData);
    },
    // 跳转到对应页面
    onPageJump(data) {
      console.log("onPageJump-----列表", data);
      this.$emit("onPageJump", data);
    },
  },
};
</script>

<style lang="scss" scoped>
.message-list-wrapper {
  .interline {
    margin: 0 5px;
    color: #333;
  }
  .message-list-item-wrap {
    display: flex;
    flex-direction: column;
    padding: 15px;
    border-bottom: 1px solid #ccc;
    .message-list-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .message-list-item-title {
        font-weight: bold;
        font-size: 16px;
      }
      .message-list-item-status {
        font-size: 12px;
        .status-unread {
          color: #f66717;
        }
      }
    }
    .message-list-item-time {
      font-family: Microsoft YaHei-Regular;
      color: #999999;
      font-size: 12px;
      padding: 5px;
    }
  }
}
</style>
